import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import { useTenantStore } from '../stores/tenantStore.js'
import { FEATURES } from '../lib/config/constants.js'

export function LanesLayout() {
  const user = useAuthStore((s) => s.user)
  const isFeatureEnabled = useTenantStore((s) => s.isFeatureEnabled)

  const isAllowedRole = user?.role === 'admin' || user?.role === 'imc'
  const isLanesEnabled = isFeatureEnabled(FEATURES.LANES)

  if (!isAllowedRole || !isLanesEnabled) return <Navigate to='/' replace />
  return <Outlet />
}
